import type { FlatInputRow } from './types'

interface FlattenOpts {
  hasTime: boolean
  resolveValue?: (dim: string, value: string) => string
  extraCols?: Record<string, unknown>
}

/** Flatten timeline/absolute/ratio rows. The nested `dims` object is expanded into one
 *  column per dim key (fixes the garbled single `dims` cell); dim order = first-seen. */
export function flattenFlat(
  rows: FlatInputRow[],
  opts: FlattenOpts,
): { columns: string[]; rows: Array<Record<string, unknown>> } {
  const dimKeys: string[] = []
  for (const r of rows) {
    if (r.dims) for (const k of Object.keys(r.dims)) if (!dimKeys.includes(k)) dimKeys.push(k)
  }
  const extraKeys = opts.extraCols ? Object.keys(opts.extraCols) : []
  const columns = [
    ...extraKeys,
    ...(opts.hasTime ? ['Time'] : []),
    ...dimKeys,
    'Value type',
    'Value',
  ]
  const outRows = rows.map((r) => {
    const row: Record<string, unknown> = { ...(opts.extraCols ?? {}) }
    if (opts.hasTime) row.Time = r.time ?? null
    for (const k of dimKeys) {
      const raw = r.dims?.[k] ?? null
      row[k] = raw != null && opts.resolveValue ? opts.resolveValue(k, raw) : raw
    }
    row['Value type'] = r.value_type
    row.Value = r.value
    return row
  })
  return { columns, rows: outRows }
}
